"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.prepareForSignOperation = exports.prepareTransaction = exports.prepareTokenTransaction = exports.prepareCoinTransaction = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var getTransactionStatus_1 = require("./getTransactionStatus");
var account_1 = require("../../account");
var logic_1 = require("./logic");
var transaction_1 = require("./transaction");
var rpc_1 = require("./api/rpc");
/**
 * Prepare basic coin transactions or smart contract interactions (other than live ERC20 transfers)
 * Should be used for transactions coming from the wallet API
 * Handling addition of gas limit
 */
var prepareCoinTransaction = function (account, typedTransaction) { return __awaiter(void 0, void 0, void 0, function () {
    var estimatedFees, amount, totalSpent, protoTransaction, _a, recipientErrors, _b, amountErrors, gasLimit, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                estimatedFees = (0, logic_1.getEstimatedFees)(typedTransaction);
                amount = typedTransaction.useAllAmount
                    ? account.balance.minus(estimatedFees)
                    : typedTransaction.amount;
                totalSpent = amount.plus(estimatedFees);
                protoTransaction = __assign(__assign({}, typedTransaction), { amount: amount });
                _a = __read((0, getTransactionStatus_1.validateRecipient)(account, typedTransaction), 1), recipientErrors = _a[0];
                _b = __read((0, getTransactionStatus_1.validateAmount)(account, protoTransaction, totalSpent), 1), amountErrors = _b[0];
                if (Object.keys(amountErrors).length || Object.keys(recipientErrors).length) {
                    return [2 /*return*/, typedTransaction];
                }
                if (!typedTransaction.data) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, rpc_1.getGasEstimation)(account, protoTransaction)];
            case 1:
                _c = _d.sent();
                return [3 /*break*/, 3];
            case 2:
                _c = transaction_1.DEFAULT_GAS_LIMIT;
                _d.label = 3;
            case 3:
                gasLimit = _c;
                return [2 /*return*/, __assign(__assign({}, protoTransaction), { amount: amount, gasLimit: gasLimit })];
        }
    });
}); };
exports.prepareCoinTransaction = prepareCoinTransaction;
/**
 * Prepare ERC20 transactions.
 * Handling addition of ERC20 transfer data and gas limit
 */
var prepareTokenTransaction = function (account, tokenAccount, typedTransaction) { return __awaiter(void 0, void 0, void 0, function () {
    var amount, protoTransaction, _a, recipientErrors, _b, amountErrors, data, gasLimit;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                amount = typedTransaction.useAllAmount
                    ? tokenAccount.balance
                    : typedTransaction.amount;
                protoTransaction = __assign(__assign({}, typedTransaction), { amount: new bignumber_js_1["default"](0) });
                _a = __read((0, getTransactionStatus_1.validateRecipient)(account, protoTransaction), 1), recipientErrors = _a[0];
                _b = __read((0, getTransactionStatus_1.validateAmount)(tokenAccount, protoTransaction, amount), 1), amountErrors = _b[0];
                if (Object.keys(amountErrors).length || Object.keys(recipientErrors).length) {
                    return [2 /*return*/, typedTransaction];
                }
                data = (0, transaction_1.getTransactionData)(__assign(__assign({}, typedTransaction), { amount: amount }));
                return [4 /*yield*/, (0, rpc_1.getGasEstimation)(account, __assign(__assign({}, protoTransaction), { recipient: tokenAccount.token.contractAddress, data: data }))];
            case 1:
                gasLimit = _c.sent();
                // Recipient isn't changed here as it would change on the UI end as well
                // The change will be handled by the `prepareForSignOperation` method
                return [2 /*return*/, __assign(__assign({}, typedTransaction), { data: data, gasLimit: gasLimit })];
        }
    });
}); };
exports.prepareTokenTransaction = prepareTokenTransaction;
/**
 * Method called to update a transaction into a state that would make it valid
 * (E.g. Adding fees, add smart contract data, etc...)
 */
var prepareTransaction = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var currency, feeData, subAccount, isTokenTransaction, typedTransaction, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                currency = account.currency;
                return [4 /*yield*/, (0, rpc_1.getFeesEstimation)(currency)];
            case 1:
                feeData = _b.sent();
                subAccount = (0, account_1.findSubAccountById)(account, transaction.subAccountId || "");
                isTokenTransaction = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount";
                typedTransaction = (0, transaction_1.getTypedTransaction)(transaction, feeData);
                if (!isTokenTransaction) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.prepareTokenTransaction)(account, subAccount, typedTransaction)];
            case 2:
                _a = _b.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, exports.prepareCoinTransaction)(account, typedTransaction)];
            case 4:
                _a = _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/, _a];
        }
    });
}); };
exports.prepareTransaction = prepareTransaction;
/**
 * Prepare the transaction for the signOperation step.
 * For now, used to changed the recipient for TokenAccount transfers
 * with the smart contract address as recipient and add the nonce
 * (which would change as well in the UI if it was done before that step)
 */
var prepareForSignOperation = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var nonce, subAccount, isTokenTransaction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, rpc_1.getTransactionCount)(account.currency, account.freshAddress)];
            case 1:
                nonce = _a.sent();
                subAccount = (0, account_1.findSubAccountById)(account, transaction.subAccountId || "");
                isTokenTransaction = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount";
                return [2 /*return*/, isTokenTransaction
                        ? __assign(__assign({}, transaction), { amount: new bignumber_js_1["default"](0), recipient: subAccount.token.contractAddress, nonce: nonce }) : __assign(__assign({}, transaction), { nonce: nonce })];
        }
    });
}); };
exports.prepareForSignOperation = prepareForSignOperation;
//# sourceMappingURL=prepareTransaction.js.map